import { getCustomProps, getNotCustomProps, getSubCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface integrations {
  APEX_SYNC: boolean
  NETSUITE_ACCOUNTING: boolean
}
export interface paymentMethods {
  action?: string
  paymentTypeId?: string
  currencyId?: string
  custom?: any
  isActive?: string
}
export interface employerRecords {
  action?: string
  code?: string
  custom?: any
  isActive?: string
  workCenters?: any
}

export interface AdditionalCodifications {
  id?: string
  name: string
  key: string
  type: string
  minLength: number
  maxLength: number
  placeholder?: string
  isMandatory: boolean
  isActive: boolean
}
export interface Company {
  id?: string
  name: string
  code: string
  accountNumber?: string
  address?: string
  cityId?: string
  configAllowedNegativeNet?: string
  contactName?: string
  contactPosition?: string
  contactTelephone?: string
  countryId?: string
  email?: string
  paymentMethods?: paymentMethods
  employerRecords?: employerRecords
  endFiscalDate?: string
  fiscalId?: string
  initFiscalDate?: string
  integrations?: integrations
  legalRepresentativeName?: string
  logo?: string
  phone?: string
  policy?: string
  signature?: string
  stateId?: string
  webSite?: string
  additionalCodifications?: AdditionalCodifications[]
}

export async function getCompanies(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = []
  if (search) {
    where.push(
      `CONCAT(companies.name,companies.code,companies.legal_representative_name,countries.name,init_fiscal_date,end_fiscal_date) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN companies.code ~ '^[0-9]+$' THEN CAST(companies.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, companies.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN companies.code ~ '^[0-9]+$' THEN CAST(companies.code AS NUMERIC) ELSE NULL END), companies.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_companies'],
    fields: [
      'companies.id',
      'companies.code',
      'companies.name',
      'countries.name as country',
      'companies.is_inactive',
      'companies.init_fiscal_date',
      'companies.end_fiscal_date',
      'companies.legal_representative_name',
      'companies.updated_at'
    ],
    join: ['INNER JOIN countries ON companies.country_id=countries.id'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getCompany(id: string): Promise<Company> {
  const join = ['INNER JOIN countries ON companies.country_id=countries.id']
  const data = await getData<any>({
    tables: ['pg_companies'],
    fields: [
      'companies.id',
      'companies.code',
      'companies.name',
      'companies.fiscal_id as fiscalId',
      'companies.country_id as countryId',
      'companies.city_id as cityId',
      'companies.phone',
      'companies.web_site as webSite',
      'companies.logo',
      'companies.address',
      'companies.init_fiscal_date as initFiscalDate',
      'companies.end_fiscal_date as endFiscalDate',
      'companies.policy',
      'companies.account_number as accountNumber',
      'companies.config_allowed_negative_net as configAllowedNegativeNet',
      'companies.legal_representative_name as legalRepresentativeName',
      'companies.legal_representative_document as legalRepresentativeDocument',
      'companies.signature',
      'companies.email',
      'companies.contact_name as contactName',
      'companies.contact_position as contactPosition',
      'companies.contact_telephone as contactTelephone',
      'companies.integrations',
      'countries.iso_code as isoCode',
      'companies.is_inactive',
      'companies.state_id as stateId',
      'companies.currency_id as currencyId',
      'companies.custom_fields as custom',
      'companies.additional_codifications as additionalCodifications',
      'companies.mx_sat_certification_number as mxSatCertificationNumber',
      'companies.mx_postal_code_place_of_issue as mxPostalCodePlaceOfIssue',
      'companies.mx_sat_stamped as mxSatStamped',
      'companies.allow_historic_after_termination as allowHistoricAfterTermination'
    ],
    join,
    where: [`companies.id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createCompany(data: any): Promise<boolean> {
  const response: any = await http.post('payroll/companies', {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    },
    employerRecords: getSubCustomProps(data.employerRecords),
    paymentMethods: getSubCustomProps(data.paymentMethods)
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateCompany(
  data: Company,
  id: string
): Promise<boolean> {
  const response: any = await http.put('payroll/companies/' + id, {
    ...getNotCustomProps(data),
    employerRecords: getSubCustomProps(data.employerRecords),
    paymentMethods: getSubCustomProps(data.paymentMethods),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function stateCompany(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(`payroll/companies/${id}/enable`, {
    enable
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteCompany(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/companies/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
